import { useAct } from 'DashboardUser/store'
import Loading from 'Shared/components/Loading'

import DashboardTargetTable from './DashboardTargetTable'
import DashboardInstructions from './DashboardInstructions'
import { RingroundSnackbar } from 'Shared/components'
import DashboardTargetCards from './DashboardTargetCards'

const TABLET_BREAKPOINT = 900

export default function PageContainer({ dashboardId }) {
  const act = useAct()
  const currentPage = useSel(s => s.local.currentPage)
  const [showInstructions, setShowInstructions] = useState(false)
  const [viewMode, setViewMode] = useState('auto') // 'auto', 'cards', 'table'
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0)

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const isMobileWidth = windowWidth <= TABLET_BREAKPOINT
  const shouldShowCards = viewMode === 'cards' || (viewMode === 'auto' && isMobileWidth)

  useEffect(() => {
    if (!dashboardId) return

    act.app.load(dashboardId)
    act.app.loadMe()
    act.app.reloadTargets()

    const storageKey = `dashboard-instructions-viewed-${dashboardId}`
    const hasViewed = localStorage.getItem(storageKey)
    setShowInstructions(!hasViewed)
    localStorage.setItem(storageKey, 'true')
  }, [dashboardId])

  useEffect(() => {
    act.app.reloadTargets()
  }, [currentPage])

  const name = useSel(s => s.dashboard.name)
  const instructions = useSel(s => s.dashboard.instructions)
  const loaded = useSel(s => s.app.loaded)

  return <div className='dashboard-user-root'>
    <RingroundSnackbar />
    <div className='topbar'>
      <a className='back' href='/'></a>
      <h1 className='dashboard-title'>
        {name}
      </h1>
      {instructions && !showInstructions && (
        <button className='button primary instructions-button' onClick={() => setShowInstructions(true)}>Instructions</button>
      )}
      {loaded && (
        <button 
          className='button secondary view-toggle-button' 
          onClick={() => setViewMode(shouldShowCards ? 'table' : 'cards')}
          aria-label="Toggle view"
        >
          {shouldShowCards ? <SvgIconsTableChart /> : <SvgIconsViewAgenda />}
        </button>
      )}
    </div>

    {instructions && showInstructions && (
      <DashboardInstructions onClose={setShowInstructions} />
    )}
    <div className='content'>
      {!loaded ? <Loading /> : <>
        {shouldShowCards ? (
          <DashboardTargetCards />
        ) : (
          <DashboardTargetTable />
        )}
      </>}
    </div>
  </div>
}
